module.exports = "/_next/static/images/pablo-kang-26e5862238c39e23542f2aea5cf5c3da.jpg";